import { lazy } from 'react';

// Lazy loading des pages principales
export const Index = lazy(() => import('../pages/Index'));
export const Auth = lazy(() => import('../pages/Auth'));
export const Evaluation = lazy(() => import('../pages/Evaluation'));
export const Resultats = lazy(() => import('../pages/Resultats'));
export const Offres = lazy(() => import('../pages/Offres'));
export const APropos = lazy(() => import('../pages/APropos'));
export const MaPrevention = lazy(() => import('../pages/MaPrevention'));
export const NotFound = lazy(() => import('../pages/NotFound'));

// Admin pages
export const AdminDashboardPro = lazy(() => import('../pages/AdminDashboardPro'));
export const AdminDocuments = lazy(() => import('../pages/AdminDocuments'));
